// <- ListProjects.js

import React from "react";

import { useEffect, useState } from "react";
import DropDownBtn from "../../common/DropDownBtn";
import DropDownBtnStatus from "../../common/DropDownBtnStatus";
import DropDownActions from "../../common/DropDownActions";
import moment from "moment";


const useProjectsTableEle = (projectList,handleDeleteProject,handleProjectEdit,updateProjectstatus) => {
  const [trow, setTrow] = useState([]);

  const [thead] = useState([
    "Project",
    "Project id",
    "Leader",
    "Team",
    "Deadline",
    "Status",
    "Action",
  ]);
  const [statusac,setstatus]=useState("");
  const handleEditProject = (project) => {
   // console.log(project);
  };
const handleDropDownOnChangestat=React.useCallback((e,project,projectList) =>{
  updateProjectstatus(e,project,projectList);
},[setstatus]);
  useEffect(() => {
    // console.log("list",projectList);
    if (projectList !== undefined) {
      //console.log("in usePRoject table ele hook", projectList);
      let trow = [];
      // projectList.map((ListOfProjects, i) => {

        let rowVal = projectList.map((project) => ({

          Project: <span className="project-name"> {project.projectName}</span>,
          "Project id": project.projectID,
          Leader: (
            //  project.projectLeaders.map((leader, i) => (
            <h2 className="table-avatar">
              <img
                className="profile-img-table"
                alt=""
                src={project.managerPicture == null || project.managerPicture == "null" || project.managerPicture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/` + project.managerPicture))}
                title={projectList[0].managerName}
              />
            </h2>
          ),
          // ))
          Team: (
            <div style={{ width: "150px" }}>
              {project.projectMembersList.map((member, i) => (
                <h2 key={i} className="table-avatar">
                  <img
                    className="profile-img-table"
                    alt=""
                    src={member.profilePicture == null || member.profilePicture == "null"||  member.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${member.profilePicture}`)}
                    title={member.employeeName}
                  />
                </h2>
              ))}
              ,
            </div>
          ),
          Deadline: <div>{moment(project.endDate).format("DD-MM-YYYY")} </div>,
          Status: (
            <div style={{ width: "150px" }}>
              <DropDownBtnStatus
                selectedOpt={
                  statusac === '' ?  (project.projectStatus === 1 ? "New" : (project.projectStatus === 2 ? "Inprogress" : ("Completed"))) : 
                  statusac === 1 ? "New" : (statusac === 2 ? "Inprogress" : ("Completed"))
                }
                dropDownOption={[
                  {
                    icon: <i className="far fa-dot-circle text-danger"></i>,
                    option: "New",
                    id :"1",
                    handleAction: (e) => handleDropDownOnChangestat(e,project,projectList),
                  },
                  {
                    icon: <i className="far fa-dot-circle text-warning"></i>,
                    option: "Inprogress",
                    id : "2",
                    handleAction: (e) => handleDropDownOnChangestat(e,project,projectList),
                  },
                  {
                    icon: <i className="far fa-dot-circle text-success"></i>,
                    option: "Completed",
                    id :"3",
                    handleAction: (e) => handleDropDownOnChangestat(e,project,projectList),
                  },
                ]}
                // handleDropDownOnChange={handleDropDownOnChangestat}
              ></DropDownBtnStatus>
            </div>
          ),
          Action: (
            <div>
              <DropDownActions
                selectedOpt={project.status}
                dropDownOption={[
                  {
                    action: "Edit",
                    handleAction: () => handleProjectEdit(project),
                  },
                  {
                    action: "Delete",
                    handleAction: () => handleDeleteProject(project),
                  },
                ]}
              ></DropDownActions>
            </div>
          ),
        }));
        setTrow(rowVal);
        // trow.push(rowVal[0]);
      // });
     // console.log("trow", trow);
      // setTrow(trow);
    }
  }, [projectList]);

  return { thead, trow };
};

export default useProjectsTableEle;
